<template>
    <div class="addon-product-container">
      <div class="product-image-container" :class="(canAddMore == false && this.currentQty == 0) ? 'disabled' :'available'">
        <img v-if="mainBadge != null" src="https://cdn.shopify.com/s/files/1/1363/8433/files/diverse.svg?v=1683569569" class="main-badge"/>
          <span v-if="secondaryBadge != null" class="secondary-badge">{{secondaryBadge}}</span>
          <img class="main-image lazyload" width="190" height="190" @click="updateProductQuantity(true)"  :data-src="product | getProductImage" >
          <div v-if="canAddMore == false && this.currentQty == 0" class="limit-alert">{{limitMessage}}</div>
          <button v-if="!isMobile()" :disabled="canAddMore == false" @click="updateProductQuantity(true)" v-show="currentQty == 0" class="happybox-button yellow">Add to Box</button>
          <div v-if="!isMobile()" class="quantity-container" v-show="currentQty > 0">
            <button @click="updateProductQuantity(false)">-</button>
            <p>{{currentQty}} per box</p>
            <button @mouseenter="setButtonHover(true)" @mouseleave="setButtonHover(false)"  v-tooltip="{content: limitMessage, show: shouldHover, trigger: ['manual'], hideOnTargetClick: false}" @click="updateProductQuantity(true)">+</button>
          </div>
      </div>
      <button v-if="isMobile()" :disabled="canAddMore == false" @click="updateProductQuantity(true)" v-show="currentQty == 0" class="happybox-button lavendar">Add</button>
      <div v-if="isMobile()" :class="!canAddMore ? 'no-more' : ''" class="quantity-container" v-show="currentQty > 0">
          <button @click="updateProductQuantity(false)">-</button>
          <p>{{currentQty}} per</p>
          <button v-tooltip="{content: limitMessage, container: false}" @click="updateProductQuantity(true)">+</button>
      </div>
      <p class="product-title">{{product.title}}</p>
      <div class="product-price-container">
        <span v-if="hasComparePrice != null" class="discount-price">{{hasComparePrice | moneySaleFormat}}</span>
        <span class="price">{{productPrice | moneySaleFormat}}</span>
      </div>
    </div>
  </template>
  <script>
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  export default {
      props: {
          product: Object,
          cartProducts: Array,
          boxQty: Number,
          maxCapacity: Number,
          currentCapacity: Number,
      },
      data() {
        return {
          isHovering: false,
          productLimit: 10,
        }
      },
      computed:{
          productPrice(){
              return this.product.variants.find(x => x.price != "").price
          },
          hasComparePrice(){
              return this.product.variants.find(x => x.price != "").compare_at_price
          },
          currentQty(){
            if(this.cartProducts){
              var product = this.cartProducts.find(x => x.id == this.product.id);
              if(product)
                return product.quantity
            }
            return 0
          },
          canAddMore(){
            if(this.maxCapacity < (this.currentCapacity + this.product.capacity))
              return false
            if((this.boxQty * (this.currentQty + 1)) > this.product.variants[0].inventory_quantity)
              return false
            if(this.currentQty >= this.productLimit)
              return false
  
            return true
          },
          limitMessage(){
            if(this.maxCapacity < (this.currentCapacity + this.product.capacity))
              return 'Your Box is too full!';
            if((this.boxQty * (this.currentQty + 1)) > this.product.variants[0].inventory_quantity)
              return 'Not enough inventory';
            if(this.currentQty >= this.productLimit)
              return 'Item limit per box'
  
            return ''
          },
          mainBadge(){
            //Check badges in the following order. 
            //Almost gone: Invetory < 20
            //Best seller: has "Filter_Badges_Best Seller" tag
            // New: has been published for less that 60 days
            var inventory = this.product.variants[0].inventory_quantity;
            if(inventory < 20)
              return "Less than 20";
        
            var badge = this.product.tags.find(y => y.includes("Filter_Badges"));
            if(badge){
                badge = badge.replace("Filter_","").split("_")
                return badge[1];
            }
  
            return null
          },
          shouldHover(){
            if(this.canAddMore == false && this.currentQty > 0 && this.isHovering == true){
              return true;
            }
            return false;
          },
          hasVariants(){
            return this.product.variants.length > 1;
          },
          secondaryBadge(){
          //Check badges in the following order. 
          // Inventory: only for storefront products
          // Minimum: has qtymin tag
          // Almost gone: Invetory < 20
          // Best seller: has "Filter_Badges_Best Seller" tag
          // New: has been published for less that 60 days

          let storefront = this.product.tags.find(x => x.includes("Storefront"))
          if(storefront){
            return `Inventory: ${this.product.variants[0].inventory_quantity}`
          } 


          let qtyMin = this.product.tags.find(x => x.includes("QTYMIN") && !x.includes("DEMAND")) 
          if(qtyMin){
            qtyMin = qtyMin.split("_");
            qtyMin = qtyMin[qtyMin.length - 1];

            return `Minimum: ${qtyMin}`;
          }

          var inventory = this.product.variants[0].inventory_quantity;
          if(inventory < 20)
            return "Less than 20";
      
          var badge = this.product.tags.find(y => y.includes("Filter_Badges"));
          if(badge){
              badge = badge.replace("Filter_","").split("_")
              return badge[1];
          }

          return null
        },
        hasMinQty(){
          let qtyMin = this.product.tags.find(x => x.includes("QTYMIN") && !x.includes("DEMAND"));
          if(qtyMin){
            qtyMin = qtyMin.split("_");
            qtyMin = qtyMin[qtyMin.length - 1];

            return parseInt(qtyMin);
          }

          return null
        }
      },
      methods:{
        isMobile() {
          return window.innerWidth < 768;
        },
        updateProductQuantity(increment){
          if(increment){
            if(this.hasMinQty && this.hasMinQty > this.boxQty){
              this.openMinQtyModal();
              return;
            }
            if(this.canAddMore)
              this.$store.commit('updateSelectedAddonProductsNew',{product: this.product, quantity: (this.currentQty + 1)});
          }
          else{
            this.$store.commit('updateSelectedAddonProductsNew', {product: this.product,quantity: (this.currentQty - 1)});
          }
        },
        loadModal(){
          if(this.canAddMore || this.currentQty > 0)
            this.$emit("loadmodal", this.product);
        },
        dateDiffInDays(a, b) {
          const _MS_PER_DAY = 1000 * 60 * 60 * 24;
          // Discard the time and time-zone information.
          const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
          const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
          return Math.floor((utc2 - utc1) / _MS_PER_DAY);
        },
        setButtonHover(state){
          this.isHovering = state;
        },
        openMinQtyModal(){
          const alertText = `${this.product.title} needs a minimum of ${this.hasMinQty} boxes. Do you wish to add that amount of boxes?`;
          Swal.fire({
              title: 'Are you sure?',
              text: alertText,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes',
              cancelButtonText: 'No, cancel!',
              reverseButtons: true
              }).then((result) => {
              if (result.isConfirmed) {
                this.changeBoxQty(this.hasMinQty);
              }
          })
        },
        changeBoxQty(qty){
            //Validate if cart products can support box qty if not show alert
            var canUpdate = this.cartProducts.filter((x) =>{
                if((qty * (x.quantity)) > x.variants[0].inventory_quantity)
                    return true

                return false
            })

            if(canUpdate.length > 0){
              this.openBoxQtyConfirmation(canUpdate);
              return
            }
            else {
              this.$emit("changeboxqty",qty);
              this.$store.commit('updateSelectedAddonProductsNew',{product: this.product, quantity: (this.currentQty + 1)});
            }
        },
        openBoxQtyConfirmation(productList){
          var productTitles = productList.map(x => x.title);
          const alertText = "The following products dont have enough inventory to match the number of boxes: " + productTitles.join(", ") + ". Do you want to remove them?";
          Swal.fire({
              title: 'Are you sure?',
              text: alertText,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, delete them!',
              cancelButtonText: 'No, cancel!',
              reverseButtons: true
              }).then((result) => {
              if (result.isConfirmed) {
                  for(let addon of productList){
                      this.removeProduct(addon);
                  }
                  this.changeBoxQty(this.hasMinQty);
              }
          })
        },
        removeProduct(product){
          this.$store.commit('removeSelectedAddonProductNew', product);
        },
      },
  }
  </script>
  
  <style scoped>
  .addon-product-container{
    width: 100%;
  }
  
  .product-image-container{
    width: 100%;
    position: relative;
    overflow: hidden;
    display: flex;
  }
  
  .product-image-container .main-image {
    width: 100%;
    height: auto;
    background-color: #F6F6F6;
  }
  
  .product-image-container.disabled img{
    opacity: 0.4;
  }
  
  .limit-alert{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    background-color: white;
    width: 100%;
    position: absolute;
    bottom: 40%;
    font-size: 1vw;
    color: black;
    font-weight: bold;
  }
  
  .happybox-button{
    position: absolute;
    width: 90%;
    bottom: -30%;
    margin: unset;
    transition: all 0.5s ease-in-out;
    left: 5%;
  }
  
  .product-image-container.available:hover .happybox-button{
    bottom: 5%;
  }
  
  .quantity-container{
    position: absolute;
    width: 100%;
    display: flex;
    align-items: stretch;
    justify-content: space-around;
    bottom: 5%;
  }
  
  .quantity-container button{
    display: flex;
    font-size: 2vw;
    width: 15%;
    line-height: 1.15;
    justify-content: center;
    align-items: center;
    background-color: white;
    border: 1px solid #F3EEFA;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px;
  }
  
  .quantity-container button:hover{
    background-color: #faf7fe
  }
  
  .quantity-container button.has-tooltip{
    opacity: 0.6;
  }
  
  .quantity-container p{
    background: #FFFFFF;
    border: 1px solid #F3EEFA;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 1%;
    width: 50%;
    font-size: 1vw;
  }
  
  .product-title{
    font-weight: 700;
    font-size: 0.9vw;
    line-height: 1.5;
    margin-top: 2%;
  }
  
  .product-price-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    font-size: 0.8vw;
    padding-bottom: 5%;
  }
  
  .product-price-container .price{
    color: #3F3D60;
  }
  
  .product-price-container .discount-price{
    color: red;
    text-decoration: line-through;
    padding-right: 5%;
  }
  
  .main-badge{
  position: absolute;
  top: 2%;
  left: 2%;
  padding: 1% 3%;
  width: 35%;
}

  .secondary-badge{
    background-color: #eff4fe;
    position: absolute;
    top: unset;
    left: unset;
    bottom: 2%;
    right: 2%;
    border: 1px solid #F3EEFA;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 1% 3%;
    font-size: 1.1vw;
    font-weight: bold;
    color: #5981d9;
  }
  
  @media screen and (max-width: 767px){
    .happybox-button{
      position: initial;
      text-transform: uppercase;
      box-shadow: 0px 1px 2px rgba(31, 41, 55, 0.08);
      margin: 3% 0% 3% 5%;
    }
    .quantity-container{
      position: relative;
      margin: 4% 0%;
    }
    .quantity-container button{
      font-size: 2rem;
      line-height: 1.51;
      color: #0F0C38;
      border-radius: 50px;
      height: 3.2rem;
      width: 3.2rem;
    }
  
    .quantity-container p{
      font-size: 1rem;
      color: #0F0C38;
      border: unset;
    }
  
    .product-title{
      font-size: 1rem;
    }
  
    .product-price-container{
      font-size: 1rem;
    }
  
    .main-badge{
      top: unset;
      bottom: 2%;
      font-size: 1rem;
    }
  
    .limit-alert{
      font-size: 3vw;
    }

    .secondary-badge{
    font-size: 1rem;
  }
  }
  
  </style>